import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-white border-t border-gray-200 py-12 px-6 md:px-20">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-center gap-10 md:gap-24">
        <div className="flex flex-col gap-2 text-center md:text-left">
          <NavLink to="/" className="text-gray-600 hover:text-teal-500 transition-colors">
            Home
          </NavLink>
          <NavLink to="/shop" className="text-gray-600 hover:text-teal-500 transition-colors">
            Shop
          </NavLink>
          <NavLink to="/contact" className="text-gray-600 hover:text-teal-500 transition-colors">
            Contact
          </NavLink>
          <NavLink to="/faq" className="text-gray-600 hover:text-teal-500 transition-colors">
            FAQ
          </NavLink>
        </div>

        <div className="flex flex-col gap-2 text-center md:text-left">
          <NavLink to="/fda-disclaimer" className="text-gray-600 hover:text-teal-500 transition-colors">
            FDA Disclaimer
          </NavLink>
          <NavLink to="/privacy-policy" className="text-gray-600 hover:text-teal-500 transition-colors">
            Privacy Policy
          </NavLink>
          <NavLink to="/terms-and-conditions" className="text-gray-600 hover:text-teal-500 transition-colors">
            Terms and Conditions
          </NavLink>
        </div>

      </div>

      <div className="text-center mt-10 text-gray-400 text-sm">
        © {new Date().getFullYear()} Futura Bio Labs. All rights reserved.
      </div>
    </footer>
  );
}